import { memo } from 'react';
import { XYCoord } from 'react-dnd';

import styled from '@mint-lib/styled';

import { Icon, SelectionListItem } from '@myn/mui';

type Props = {
  name: string;
  currentOffset: XYCoord;
};

const DimensionRowLayer = ({ name, currentOffset }: Props) => {
  return (
    <DraggableItem
      currentOffset={currentOffset}
      text={name}
      startAdornment={<Icon component="Draggable" />}
    />
  );
};

const DraggableItem = styled(SelectionListItem)<{ currentOffset: XYCoord }>`
  overflow: hidden;
  position: relative;
  top: ${({ currentOffset }) => `${currentOffset.y - 20}px`};
  left: ${({ currentOffset }) => `${currentOffset.x - 20}px`};
  width: 320px;
  background-color: ${({ theme }) => theme.palette.ui.field02};
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
`;

export default memo(DimensionRowLayer);
